import { render, staticRenderFns } from "./Dealers.list.vue?vue&type=template&id=98764dea&"
import script from "./Dealers.list.vue?vue&type=script&lang=js&"
export * from "./Dealers.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports